import { media } from '../../styles';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 2 1 auto;
  flex-direction: row;
  padding: ${({ theme }) => `${theme.spacing.base.sm} 0`};

  ${media.mobilePortrait} {
    flex-direction: column;
  }
`;

export const Divider = styled.div`
  display: none;

  ${media.mobilePortrait} {
    border-top: 1px solid ${({ theme }) => theme.typography.color.tertiary};
    display: flex;
    flex-direction: row;
    margin: ${({ theme }) => `${theme.spacing.mobile.xxxl} 0`};
  }
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: auto;
  flex: 2 1 auto;
`;

type Props = {
  direction: 'row' | 'column';
};

export const MainButtonsContainer = styled.div<Props>`
  display: flex;
  flex: 1 1 auto;
  flex-direction: ${({ direction }) => direction};
`;
